export default __webpack_public_path__ + "static/media/program_banner_En.21f687f4.webp";